import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { hasPermission, PERMISSIONS, useCurrentMembership } from '@/lib/permissions';
import { useChurchStore } from '@/stores/church-store';

export interface LeadershipGroupTab {
  id: string;
  name: string;
  type: 'manual' | 'template';
  category: 'committee' | 'group';
  isActive: boolean;
}

export const leadershipGroupsQueryKey = ['leadership', 'groups'] as const;

export const useLeadershipGroups = () => {
  const enabledModules = useChurchStore((state) => state.enabledModules);
  const groupsModuleEnabled = enabledModules.some((module) => module.code === 'groups');
  const membership = useCurrentMembership();
  const canViewGroups = hasPermission(membership, PERMISSIONS.GROUPS_VIEW);

  return useQuery({
    queryKey: leadershipGroupsQueryKey,
    queryFn: async () => {
      const result = await api.get<{ data: LeadershipGroupTab[] }>(
        '/groups?pageSize=100&hasLeadership=true',
      );
      return result.data.sort((left, right) => left.name.localeCompare(right.name));
    },
    enabled: groupsModuleEnabled && canViewGroups,
  });
};
